import { createContext, useContext, useState, useCallback } from "react";

export const LANGS = ["it", "en", "fr", "es"];

const dict = {
  it: {
    nav_home: "Home", nav_about: "Su di me", nav_writing: "Scrittura", nav_video: "Video",
    nav_short: "Short Video", nav_audio: "Audio / Podcast", nav_premium: "Premium",
    nav_shop: "Shop", nav_courses: "Corsi", nav_instagram: "Instagram", nav_contact: "Contatti",
    login: "Accedi", logout: "Esci", admin: "Gestione", menu: "Menu", close: "Chiudi",
    hero_intro: "Il mio spazio personale",
    explore: "Esplora", enter: "Entra", read: "Leggi", watch: "Guarda", listen: "Ascolta",
    discover_about: "Scopri di più su di me",
    featured: "In evidenza", back: "Indietro", all: "Tutti",
    writing_desc: "Pensieri, riflessioni, osservazioni e idee scritte.",
    video_desc: "Contenuti video più lunghi e approfonditi.",
    short_desc: "Contenuti video brevi.",
    audio_desc: "Audio e podcast da ascoltare.",
    empty_title: "Ancora nessun contenuto",
    empty_desc: "Questo spazio è pronto. I nuovi contenuti appariranno qui.",
    premium_title: "Premium", premium_desc: "Contenuti esclusivi, riflessioni approfondite e molto altro.",
    subscribe: "Abbonati", per_month: "/mese", per_year: "/anno",
    locked: "Contenuto Premium", unlock: "Sblocca con Premium",
    shop_title: "Shop", shop_desc: "Prodotti digitali, ebook e risorse.",
    courses_title: "Corsi", courses_desc: "Percorsi strutturati in moduli e lezioni.",
    contact_title: "Contatti", contact_desc: "Scrivimi, sarò felice di leggerti.",
    name: "Nome", email: "Email", message: "Messaggio", send: "Invia", buy: "Acquista",
    price_free: "Gratis", modules: "Moduli", lessons: "Lezioni", read_more: "Continua a leggere",
    reading_time: "min di lettura", newsletter_cta: "Resta nel mio mondo", newsletter_sub: "Iscriviti",
    payment_success: "Pagamento completato", payment_success_desc: "Grazie. Il tuo accesso è attivo.",
    payment_cancel: "Pagamento annullato", payment_cancel_desc: "Nessun addebito effettuato.",
    go_home: "Torna alla home", my_account: "Il mio account", not_found: "Non trovato",
    statement: "Non sono qui per dirti cosa pensare. Sono qui per mostrarti come vedo le cose.",
  },
  en: {
    nav_home: "Home", nav_about: "About me", nav_writing: "Writing", nav_video: "Video",
    nav_short: "Short Videos", nav_audio: "Audio / Podcast", nav_premium: "Premium",
    nav_shop: "Shop", nav_courses: "Courses", nav_instagram: "Instagram", nav_contact: "Contact",
    login: "Sign in", logout: "Sign out", admin: "Manage", menu: "Menu", close: "Close",
    hero_intro: "My personal space",
    explore: "Explore", enter: "Enter", read: "Read", watch: "Watch", listen: "Listen",
    discover_about: "Discover more about me",
    featured: "Featured", back: "Back", all: "All",
    writing_desc: "Written thoughts, reflections, observations and ideas.",
    video_desc: "Longer, more developed video content.",
    short_desc: "Short-form video content.",
    audio_desc: "Audio and podcast to listen to.",
    empty_title: "No content yet",
    empty_desc: "This space is ready. New content will appear here.",
    premium_title: "Premium", premium_desc: "Exclusive content, deeper reflections and more.",
    subscribe: "Subscribe", per_month: "/month", per_year: "/year",
    locked: "Premium content", unlock: "Unlock with Premium",
    shop_title: "Shop", shop_desc: "Digital products, ebooks and resources.",
    courses_title: "Courses", courses_desc: "Structured paths in modules and lessons.",
    contact_title: "Contact", contact_desc: "Write to me, I'd love to hear from you.",
    name: "Name", email: "Email", message: "Message", send: "Send", buy: "Buy",
    price_free: "Free", modules: "Modules", lessons: "Lessons", read_more: "Keep reading",
    reading_time: "min read", newsletter_cta: "Stay in my world", newsletter_sub: "Subscribe",
    payment_success: "Payment complete", payment_success_desc: "Thank you. Your access is active.",
    payment_cancel: "Payment cancelled", payment_cancel_desc: "No charge was made.",
    go_home: "Back to home", my_account: "My account", not_found: "Not found",
    statement: "I'm not here to tell you what to think. I'm here to show you how I see things.",
  },
  fr: {
    nav_home: "Accueil", nav_about: "À propos", nav_writing: "Écriture", nav_video: "Vidéo",
    nav_short: "Vidéos courtes", nav_audio: "Audio / Podcast", nav_premium: "Premium",
    nav_shop: "Boutique", nav_courses: "Cours", nav_instagram: "Instagram", nav_contact: "Contact",
    login: "Se connecter", logout: "Se déconnecter", admin: "Gérer", menu: "Menu", close: "Fermer",
    hero_intro: "Mon espace personnel",
    explore: "Explorer", enter: "Entrer", read: "Lire", watch: "Regarder", listen: "Écouter",
    discover_about: "En savoir plus sur moi",
    featured: "À la une", back: "Retour", all: "Tous",
    writing_desc: "Pensées, réflexions, observations et idées écrites.",
    video_desc: "Contenus vidéo plus longs et approfondis.",
    short_desc: "Contenus vidéo courts.",
    audio_desc: "Audio et podcast à écouter.",
    empty_title: "Aucun contenu pour l'instant",
    empty_desc: "Cet espace est prêt. Les nouveaux contenus apparaîtront ici.",
    premium_title: "Premium", premium_desc: "Contenus exclusifs, réflexions approfondies et plus.",
    subscribe: "S'abonner", per_month: "/mois", per_year: "/an",
    locked: "Contenu Premium", unlock: "Débloquer avec Premium",
    shop_title: "Boutique", shop_desc: "Produits numériques, ebooks et ressources.",
    courses_title: "Cours", courses_desc: "Parcours structurés en modules et leçons.",
    contact_title: "Contact", contact_desc: "Écrivez-moi, avec plaisir.",
    name: "Nom", email: "Email", message: "Message", send: "Envoyer", buy: "Acheter",
    price_free: "Gratuit", modules: "Modules", lessons: "Leçons", read_more: "Continuer la lecture",
    reading_time: "min de lecture", newsletter_cta: "Restez dans mon monde", newsletter_sub: "S'inscrire",
    payment_success: "Paiement effectué", payment_success_desc: "Merci. Votre accès est actif.",
    payment_cancel: "Paiement annulé", payment_cancel_desc: "Aucun débit effectué.",
    go_home: "Retour à l'accueil", my_account: "Mon compte", not_found: "Introuvable",
    statement: "Je ne suis pas là pour vous dire quoi penser. Je suis là pour vous montrer comment je vois les choses.",
  },
  es: {
    nav_home: "Inicio", nav_about: "Sobre mí", nav_writing: "Escritura", nav_video: "Vídeo",
    nav_short: "Vídeos cortos", nav_audio: "Audio / Podcast", nav_premium: "Premium",
    nav_shop: "Tienda", nav_courses: "Cursos", nav_instagram: "Instagram", nav_contact: "Contacto",
    login: "Iniciar sesión", logout: "Salir", admin: "Gestionar", menu: "Menú", close: "Cerrar",
    hero_intro: "Mi espacio personal",
    explore: "Explorar", enter: "Entrar", read: "Leer", watch: "Ver", listen: "Escuchar",
    discover_about: "Descubre más sobre mí",
    featured: "Destacado", back: "Atrás", all: "Todos",
    writing_desc: "Pensamientos, reflexiones, observaciones e ideas escritas.",
    video_desc: "Contenidos de vídeo más largos y desarrollados.",
    short_desc: "Contenidos de vídeo cortos.",
    audio_desc: "Audio y podcast para escuchar.",
    empty_title: "Aún no hay contenido",
    empty_desc: "Este espacio está listo. El nuevo contenido aparecerá aquí.",
    premium_title: "Premium", premium_desc: "Contenido exclusivo, reflexiones profundas y más.",
    subscribe: "Suscribirse", per_month: "/mes", per_year: "/año",
    locked: "Contenido Premium", unlock: "Desbloquear con Premium",
    shop_title: "Tienda", shop_desc: "Productos digitales, ebooks y recursos.",
    courses_title: "Cursos", courses_desc: "Rutas estructuradas en módulos y lecciones.",
    contact_title: "Contacto", contact_desc: "Escríbeme, me encantará leerte.",
    name: "Nombre", email: "Email", message: "Mensaje", send: "Enviar", buy: "Comprar",
    price_free: "Gratis", modules: "Módulos", lessons: "Lecciones", read_more: "Seguir leyendo",
    reading_time: "min de lectura", newsletter_cta: "Quédate en mi mundo", newsletter_sub: "Suscribirse",
    payment_success: "Pago completado", payment_success_desc: "Gracias. Tu acceso está activo.",
    payment_cancel: "Pago cancelado", payment_cancel_desc: "No se realizó ningún cargo.",
    go_home: "Volver al inicio", my_account: "Mi cuenta", not_found: "No encontrado",
    statement: "No estoy aquí para decirte qué pensar. Estoy aquí para mostrarte cómo veo las cosas.",
  },
};

const LangContext = createContext(null);
export const useLang = () => useContext(LangContext);

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("unf_lang") || "it");
  const setLang = useCallback((l) => {
    setLangState(l);
    localStorage.setItem("unf_lang", l);
  }, []);
  const t = useCallback((key) => (dict[lang] && dict[lang][key]) || dict.it[key] || key, [lang]);
  return <LangContext.Provider value={{ lang, setLang, t, langs: LANGS }}>{children}</LangContext.Provider>;
}
